import { DeleteLoyaltyProgramState } from './deleteLoyaltyProgram.types'

const initialState: DeleteLoyaltyProgramState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
